import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Label } from "../ui/label";
import { RETURN_CREATION_DIALOG } from "@/constants/dialog-constants";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "@/store/reducers/dialogReducer";
import { RootState } from "@/store/store";
import { Switch } from "../ui/switch";
import RequestCreationForm from "./return-creation/RequestCreationForm";
import StandardCreationForm from "./return-creation/StandardCreationForm";

export const ReturnCreationDialog: React.FC = () => {
  const dispatch = useDispatch();
  const [isRequestMode, setIsRequestMode] = useState(false);
  const { isOpen, dialogType } = useSelector(
    (state: RootState) => state.dialog
  );
  const isOpened = isOpen && dialogType === RETURN_CREATION_DIALOG;

  const handleClose = () => {
    dispatch(closeDialog());
    setIsRequestMode(false);
  };

  return (
    <Dialog open={isOpened} onOpenChange={handleClose}>
      <DialogContent className="flex flex-col gap-4 max-w-2xl" hasClose>
        <DialogHeader>
          <DialogTitle>
            <div className="flex justify-between">
              <p className="text-lg font-semibold">Crée une tournée</p>

              <div className="flex items-center gap-2">
                <Label className="font-normal">Par demande</Label>
                <Switch
                  checked={isRequestMode}
                  onCheckedChange={() => setIsRequestMode(!isRequestMode)}
                />
              </div>
            </div>
          </DialogTitle>
        </DialogHeader>
        {isRequestMode ? <RequestCreationForm /> : <StandardCreationForm />}
      </DialogContent>
    </Dialog>
  );
};
